var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"3"}},[_c('customer-guest-information')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }